module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/vision/vision-label/vision-label.component.css
// module id = ./src/app/vision/vision-label/vision-label.component.css
// module chunks = main